import About from "./About";
import AdvisorsBackers from "./AdvisorsBackers";
import AirDrop from "./AirDrop";
import Blog from "./Blog";
import BlogDetails from "./BlogDetails";
import Contact from "./Contact";
import Faq from "./Faq";
import HelpCenter from "./HelpCenter";
import Home01 from "./Home01";
import ParticipantAssets from "./ParticipantAssets";
import Partners from "./Partners";
import RoadMap from "./RoadMap";
import Team from "./Team";
import VisionsMission from "./VisionsMission";
import UsingEkival from "./UsingEkival";





const routes = [
  { path: '/', component: <Home01 /> },
  // { path: '/home-v2', component: <Home02 />},
  // { path: '/home-v3', component: <Home03 />},

  { path: '/faq', component: <Faq /> },
  { path: '/blog', component: <Blog /> },
  { path: '/blog-details', component: <BlogDetails /> },
  { path: '/visions-mission', component: <VisionsMission /> },
  { path: '/help-center', component: <HelpCenter /> },
  { path: '/participants-assets', component: <ParticipantAssets /> },
  { path: '/advisors-backers', component: <AdvisorsBackers /> },
  { path: '/partners', component: <Partners /> },
  { path: '/about', component: <About /> },
  { path: '/road-map', component: <RoadMap /> },
  { path: '/team', component: <Team /> },
  { path: '/contact', component: <Contact /> },
  { path: '/air-drop', component: <AirDrop /> },
  { path: '/using-ekival', component: <UsingEkival /> }
]

export default routes;